// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__kxOo0","notes":"Notes_notes__2_fv_","note":"Notes_note__9oPg4","markdown":"Notes_markdown__3aOH-"};